export const formatDate = (dateString: string) => {
  if (!dateString) {
    return '';
  }

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const formatMessageTime = (date: Date): string => {
  return new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

export const getActivationDate = (license: any): string => {
  if (license.activationDate) {
    return license.activationDate;
  }

  if (license.user?.updatedAt) {
    return license.user.updatedAt;
  }

  if (license.user?.createdAt) {
    return license.user.createdAt;
  }

  if (license.lastActivity) {
    return license.lastActivity;
  }

  if (license._id) {
    const timestamp = parseInt(license._id.substring(0, 8), 16) * 1000;
    const date = new Date(timestamp);
    if (!isNaN(date.getTime())) {
      return date.toISOString();
    }
  }

  return new Date().toISOString();
};